// Stub for rollup and consumers of npm package
export default class TimerWorkerStub {
    addEventListener(_eventName: string, _callback: any) {}
    postMessage(_message: any, _data?: any) {}
    removeEventListener(_eventName: string, _callback: any) {}
    terminate() {}
}
